export const environment = {
  production: false,
  URL_SERVER: 'http://212.56.35.133:3001',
  URL_LOCAL_SERVER: 'http://212.56.35.133:8080',
  URL_S3: 'https://d3q0kt5yih1b7n.cloudfront.net/',
  googleAnalyticsId: '',
  matomoSiteId: '1',
  matomoUrl: '//analytics.adaptai.com/',
  DevAccess: true,
};
